import { css } from '@emotion/react';
import { Button } from 'client/components/Button';
import { DropdownMenu } from 'client/components/DropdownMenu';
import { AddTime } from 'client/components/Icons/AddTime';
import { useDeploymentEnabledState } from '../useDeploymentEnabledState';

export const AddTimeButton = ({ deploymentID }: { deploymentID: number | null }) => {
  const { enabled, isToggleable, startOptions, timeRunUntil, addTime } = useDeploymentEnabledState({
    deploymentID,
    action: 'add',
  });

  if (!enabled) return null;
  if (!timeRunUntil) return null;

  return (
    <DropdownMenu items={startOptions} onSelect={addTime}>
      <Button
        icon={<AddTime />}
        tooltip="Add time to shutdown timer"
        tooltipSide="top"
        disabled={!deploymentID || !isToggleable || !enabled}
        css={addTimeButton}
      />
    </DropdownMenu>
  );
};

const addTimeButton = css`
  .icon {
    transform: translateY(0.5px);
  }
`;
